import classNames from 'classnames/bind';
import React from 'react';
import Button from '../../../common/button/Button';
import useWarningToast from '../../../context/toast/useWarningToast';
import useMultiLanguage from '../../../hook/useMultiLanguage';
import style from './JDProcess.module.scss';
import { TProgressStatus } from '../../../interface/recruit/IRecruitSetting';
import { TWriteButtonStatus, WRITE_BUTTON_STATUS } from '../../../interface/recruit/IJD';
const cx = classNames.bind(style);

interface IProps {
  show?: boolean;
  writeButtonStatus?: TWriteButtonStatus;
  progressStatus: TProgressStatus;
  readonly: boolean;
  resumeUpdateUrl: string;
  myPageUrl: string;
}

const JDProcessJobflexButtons = ({
  show,
  writeButtonStatus,
  progressStatus,
  readonly,
  resumeUpdateUrl,
  myPageUrl,
}: IProps) => {
  const { setPreviewDisabledWarningToast } = useWarningToast();
  const { multiLanguageText } = useMultiLanguage();

  if (!show) {
    return null;
  }

  const isDisabled = progressStatus === 'ENDED';

  const handleClickModifyResume = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (readonly) return setPreviewDisabledWarningToast();
    window.open(resumeUpdateUrl);
  };

  const handleClickMyPage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (readonly) return setPreviewDisabledWarningToast();
    window.open(myPageUrl);
  };

  const isClosed = writeButtonStatus === WRITE_BUTTON_STATUS.CLOSE;

  if (isClosed) {
    return null;
  }

  return (
    <div className={cx('jobflex-button-wrapper')}>
      <Button variant={'outlined'} color={'teal'} disabled={isDisabled} onClick={handleClickModifyResume}>
        {multiLanguageText('지원서 수정', 'Edit Resume')}
      </Button>
      <Button variant={'secondary'} color={'default'} disabled={isDisabled} onClick={handleClickMyPage}>
        {multiLanguageText('마이페이지', 'My Page')}
      </Button>
    </div>
  );
};

export default JDProcessJobflexButtons;
